import React from 'react'

export const VaccineFields = ({ user, handleChange }) => {
  return (
    <>
      <h3 className="text-18 text-purple-dark mb-12">Vaccination Status</h3>
      <div className="bg-white border-1 border-gray-200 shadow-100 rounded-10 px-20 sm:px-32 pt-32 mb-32">
        <fieldset className="border-b-default border-gray-200 mb-32 pb-20 px-0">
          <legend className="text-16 text-purple-dark font-bold mb-12">
            Have you been vaccinated for COVID-19?
          </legend>
          <div className="mb-12">
            <input
              className="mr-16"
              type="radio"
              id="vaccineStatus-choice-1"
              name="vaccineStatus"
              value="all"
              onChange={handleChange}
              defaultChecked={user.profile.vaccineStatus === 'all'}
            />
            <label htmlFor="vaccineStatus-choice-1">
              I have received all my required doses.
            </label>
          </div>
          <div className="mb-12">
            <input
              className="mr-16"
              type="radio"
              id="vaccineStatus-choice-2"
              name="vaccineStatus"
              value="some"
              onChange={handleChange}
              defaultChecked={user.profile.vaccineStatus === 'some'}
            />
            <label htmlFor="vaccineStatus-choice-2">
              I have received one and need more.
            </label>
          </div>
          <div className="mb-12">
            <input
              className="mr-16"
              type="radio"
              id="vaccineStatus-choice-3"
              name="vaccineStatus"
              value="none"
              onChange={handleChange}
              defaultChecked={user.profile.vaccineStatus === 'none'}
            />
            <label htmlFor="vaccineStatus-choice-3">
              I have not received any doses.
            </label>
          </div>
        </fieldset>
        <fieldset className="pb-20 px-0">
          <legend className="text-16 text-purple-dark font-bold mb-12">
            If you haven’t been vaccinated, do you plan to be when it becomes
            available?
          </legend>
          <div className="mb-12">
            <input
              className="mr-16"
              type="radio"
              id="vaccinePlan-choice-1"
              name="vaccinePlan"
              value="yes"
              onChange={handleChange}
              defaultChecked={user.profile.vaccinePlan === 'yes'}
            />
            <label htmlFor="vaccinePlan-choice-1">Yes</label>
          </div>
          <div className="mb-12">
            <input
              className="mr-16"
              type="radio"
              id="vaccinePlan-choice-2"
              name="vaccinePlan"
              value="no"
              onChange={handleChange}
              defaultChecked={user.profile.vaccinePlan === 'no'}
            />
            <label htmlFor="vaccinePlan-choice-2">No</label>
          </div>
          <div className="mb-12">
            <input
              className="mr-16"
              type="radio"
              id="vaccinePlan-choice-3"
              name="vaccinePlan"
              value="unsure"
              onChange={handleChange}
              defaultChecked={user.profile.vaccinePlan === 'unsure'}
            />
            <label htmlFor="vaccinePlan-choice-3">Unsure</label>
          </div>
        </fieldset>
      </div>
    </>
  )
}
